<template>
<!--  <div class="background_style">-->
<!--  <div class="container">-->
<!--    <div class="main">-->
<!--      <div class="main_left">-->
<!--        <img alt="" src="@/assets/images/zzu.png"/>-->
<!--      </div>-->
<!--      <div class="main_right">-->
<!--        <div class="title_reg">-->
<!--          <h2>Login</h2>-->
<!--          <p @click="goReg">没有账号？点击注册</p>-->
<!--        </div>-->
<!--        <div class="inp_user">-->
<!--          <el-form ref="formRef" :model="form" :rules="rules">-->
<!--            <el-form-item label="账号：" label-width="100px" prop="userName">-->
<!--              <el-input v-model="form.userName" placeholder="用户名或邮箱"/>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="密码：" label-width="100px" prop="userPassword">-->
<!--              <el-input v-model="form.userPassword" placeholder="" @keydown.enter="goHome"/>-->
<!--            </el-form-item>-->
<!--          </el-form>-->
<!--        </div>-->
<!--        <div class="confirm_user">-->
<!--          <button @click="goHome">Enter</button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  </div>-->
    <section>

        <div class="form-box">
            <div class="form-value">
                <el-form action="" ref="formRef" :model="form" :rules="rules">
                    <h2><img src="../assets/images/logo2.png" alt=""></h2>
                    <div class="inputbox">
                        <input type="username" v-model="form.userName">
                        <label for="">username</label>
                    </div>
                    <div class="inputbox">
                        <input type="password" v-model="form.userPassword" @keydown.enter="goHome">
                        <label for="">password</label>
                    </div>
                    <div class="forget">
                        <label for=""><input type="checkbox">save</label>
                        <a href="#">forget password</a>
                    </div>
                    <button  @click="goHome">login</button>
                    <div class="register">
                        <p>first <a @click="goReg">register </a></p>
                    </div>
                </el-form>
            </div>
        </div>
    </section>



</template>

<script setup>
import {ref} from 'vue'
import {ElMessage} from 'element-plus'
import axios from '@/util/axios'
import router from "@/router";

const form = ref({
  userName: '',
  email: '',
  userPassword: '',
})
const rules = ref({
  userName: [
    {required: true, message: '请输入用户名或邮箱', trigger: 'blur'}
  ],
  userPassword: [
    {required: true, message: '请输入密码', trigger: 'blur'}
  ]
})
const formRef = ref(null)

const goHome = async () => {
  form.value.email = form.value.userName
  formRef.value.validate(async (valid) => {
    if (valid) { // 所有input里面均存在有效值
      try {
        let res = await axios.post("user/login", form.value)
          console.log(res)
        let data = res.data
        console.log(data)
        if (data.code === 200) {
          ElMessage.success("登录成功")
            console.log(data)
          window.sessionStorage.setItem("token", data.token)
          window.sessionStorage.setItem("userInfo", JSON.stringify(form.value))
          router.replace('/home')
        } else {
          ElMessage.error(data.msg)
        }
      } catch (err) {
        console.log("error:" + err)
        ElMessage.error("服务器出错，请联系管理员！")
      }
    } else {
      ElMessage.error("请仔细检查输入")
    }
  })
}

const goReg = () => {
  router.replace('/register')
}

</script>

<style scoped>
/** {*/
/*  margin: 0;*/
/*  padding: 0;*/
/*  box-sizing: border-box;*/
/*}*/

/*:deep(.el-form-item){*/
/*  margin-bottom: 30px;*/
/*}*/

/*.container {*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  min-height: 100vh;*/
/*  min-width: 1040px;*/
/*  position: relative;*/
/*}*/

/*.container::before,*/
/*.container::after {*/
/*  position: absolute;*/
/*  !* background-size: cover; *!*/
/*  content: "";*/
/*  bottom: 0;*/
/*  z-index: -2;*/
/*  background-size: contain;*/
/*  background-repeat: no-repeat;*/
/*}*/

/*.container::before {*/
/*  width: 394px;*/
/*  height: 468px;*/
/*  left: 0;*/
/*}*/

/*.container::after {*/
/*  width: 487px;*/
/*  height: 412px;*/
/*  right: 0;*/
/*}*/

/*.main {*/
/*  min-width: 1000px;*/
/*  min-height: 564px;*/
/*  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);*/
/*  z-index: 1;*/
/*  display: flex;*/
/*}*/

/*.main_left > img {*/
/*  position: relative;*/
/*  top: 30px;*/
/*  width: 500px;*/
/*  height: 500px;*/
/*}*/

/*.main .main_right {*/
/*  flex: 50%;*/
/*  min-width: 500px;*/
/*  min-height: 564px;*/
/*  background: #ffffff;*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  padding: 64px 70px 48px;*/
/*  font-size: 40px;*/
/*  color: #6c5ce7;*/
/*}*/

/*h2 {*/
/*  text-align: center;*/
/*}*/

/*.title_reg {*/
/*  position: relative;*/
/*  padding-bottom: 80px;*/
/*}*/

/*.title_reg > p {*/
/*  position: absolute;*/
/*  top: 120px;*/
/*  right: 0;*/
/*  font-size: 14px;*/
/*  cursor: pointer;*/
/*}*/

/*.inp_user input {*/
/*  display: block;*/
/*  width: 100%;*/
/*  height: 40px;*/
/*  margin-bottom: 20px;*/
/*  padding: 9px 14px;*/
/*  opacity: 0.5;*/
/*  outline: 0;*/
/*  font-size: 1rem;*/
/*  border-radius: 50px;*/
/*}*/

/*.ckx_user {*/
/*  position: relative;*/
/*  font-size: 14px;*/
/*}*/

/*.ckx_user input {*/
/*  cursor: pointer;*/
/*  zoom: 1.3;*/
/*  vertical-align: -1px;*/
/*}*/

/*.ckx_user span {*/
/*  display: inline-block;*/
/*  margin-left: 5px;*/
/*}*/

/*.confirm_user button {*/
/*  position: relative;*/
/*  left: 15%;*/
/*  width: 70%;*/
/*  height: 50px;*/
/*  letter-spacing: 1px;*/
/*  text-indent: 15px;*/
/*  font-size: 18px;*/
/*  color: #ffffff;*/
/*  background: #ffb400;*/
/*  font-weight: bold;*/
/*  border-radius: 50px;*/
/*  cursor: pointer;*/
/*  margin-bottom: 20px;*/
/*}*/
/*.background_style{*/
/*  width:100%;*/
/*  height:100%;*/
/*  position:fixed;*/
/*  background-size:100% 100%;*/
/*  background-repeat: no-repeat;*/
/*  background-image: url("@/assets/images/daguowaijiao.jpg");*/
/*}*/

* {
    margin: 0;
    padding: 0;
}

section {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    /* background-color: aquamarine */
    background:url('../assets/images/loginbac.jpg') no-repeat;
    background-position: center;
    background-size: cover;
}

.form-box {
    position: relative;
    width: 400px;
    height: 450px;
    /* background-color: red; */
    background-color: transparent;
    border: 2px solid rgb(255, 255, 255, 0.5);
    backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
}

h2{
    font-size: 32px;
    color: white;
    text-align: center;
}

.inputbox {
    position: relative;
    margin: 30px 0;
    width: 310px;
    border-bottom: 2px solid white;
}

.inputbox label{
    position: absolute;
    top: 50%;
    left: 5px;
    transform: translateY(-50%);
    color: white;
    font-size: 16px;
    pointer-events: none;
    transition: 0.5s;
}

input:focus ~ label,
input:valid ~ label
{
    top: -5px;
}

.inputbox input{
    width: 100%;
    height: 50px;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 16px;
    padding: 0 35px 0 5px;
    color:#fff;
}

.inputbox ion-icon {
    position: absolute;
    right: 8px;
    top: 20px;
    font-size: 18px;
    color: #fff;
}

.forget {
    margin: -15px 0 15px;
    font-size: 14px;
    color: #fff;
    display: flex;
    justify-content: center;
}

.forget label input {
    margin-left: 5px
}

.forget a {
    text-decoration: none;
    color: #fff;
    margin-left: 10px;
}

button {
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
}

.register {
    font-size: 14px;
    color: #fff;
    text-align: center;
    margin: 25px 0 10px;
}
</style>